// extracted by mini-css-extract-plugin
module.exports = {"headerBackground":"HeaderBackground_headerBackground__BIuWT","opaque":"HeaderBackground_opaque__L1qz2"};